/* eslint-disable array-callback-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { UseAuth } from 'hook/auth-hook';
import { RestUseCase } from 'service/api/rest/rest-usecase';
import { handleRequest } from 'service/api/request-common';
import { getLocalStorage } from 'data/cache/localstorage-cache';
import SyntheticPage from 'pages/layout/analysis/synthetic-page';
import ErrorNotAuthorizedPage from 'pages/layout/error/error-not-authorized-page';
import { SelectOptionInterface } from '../../../@types/entity/interface/select-option-interface';
import { HeaderNavegationList } from 'helper/adapter/headerNavigation/header-navegation-adapter';
import { SyntheticFilterPlanningAdapter } from 'helper/adapter/planning/synthetic-filter-planning-adapter';
import { ParseDateToBr, ParseDateToBrWithHours } from 'helper/format-date-helper';
import { getEnv } from 'helper/window-helper';
import { TableDescriptions } from '../../../@types/interfaces/table-interface';
import { checkColumns } from 'helper/table-columns-helper';
import { ColumsTableSyntheticAdapter } from 'helper/adapter/columsTable/colums-table-synthetic-adapter';
import { FilterRequest } from '../../../@types/interfaces/filter-request-interface';
import { UseAlert } from 'hook/alert-hook';
import { showErrorAlert, showAlertPorStatus } from 'helper/show-alert-helper';
import { finalizarOriginar } from 'helper/fluxo-aprovacao-pedido-helper';
import { useNavigate } from 'react-router-dom';
import { FluxoAprovacaoPedidoUseCase } from 'service/api/rest/fluxo-aprovacao-pedido-usecase';
import { buscarConfiguracaoFluxoAprovacao } from 'helper/fluxo-aprovacao-empresa-helper';

export const SyntheticFactory: React.FC = () => {
  /**
   *
   *
   *
   *
   *  endpoint */
  const ENDPOINT_TABLE = getEnv('REACT_APP_END_POINT_SYNTHETIC');
  const ENDPOINT_ORDER = getEnv('REACT_APP_END_POINT_SYNTHETIC_GENERATE_ORDER');
  const ENDPOINT_REQUEST_ORDER = getEnv('REACT_APP_END_POINT_SYNTHETIC')! + '/solicitar-pedido';
  const ENDPOINT_PLANNING = getEnv('REACT_APP_END_POINT_SYNTHETIC') + '/filtros';
  const END_POINT_ITEM = getEnv('REACT_APP_END_POINT_ITEM');
  const END_POINT_MOVEMENT = getEnv('REACT_APP_END_POINT_MOVEMENT');
  const ENDPOINT_FILIAL = getEnv('REACT_APP_END_POINT_FILIAL')!;
  const END_POINT_ORIGINAL_ITEMS_TRACKS = getEnv('REACT_APP_END_POINT_ORIGINAL_ITEMS_TRACKS')!;
  const END_POINT_ITEM_TRACKS = getEnv('REACT_APP_END_POINT_ITEM_TRACKS')!;
  const END_POINT_ITEM_BASE = getEnv('REACT_APP_END_POINT_ITEM_BASE')!;
  const LOCALSTORAGE_PLANNING = getEnv('REACT_APP_LOCALSTORAGE_PLANNING_SYNTHETIC')!;
  const END_POINT_CORRELATE = getEnv('REACT_APP_END_POINT_CORRELATE_ICON')!;
  const LOCALSTORAGE_COLUMS_ORDER = getEnv('REACT_APP_LOCALSTORAGE_COLUMS_SYNTHETIC')! + '_order';
  const ENDPOINT_MANUFACTURER = getEnv('REACT_APP_END_POINT_MANUFACTURER');
  const LOCALSTORAGE_COLUMS = getEnv('REACT_APP_LOCALSTORAGE_COLUMS_SYNTHETIC')!;
  const ENDPOINT_CAMPANHAS_ATIVAS = getEnv('REACT_APP_END_POINT_CAMPANHAS_ATIVAS')!;
  const END_POINT_ITEM_BASE_CODE = getEnv('REACT_APP_END_POINT_ITEM_BASE_CODE')!;
  const ENDPOINT_FLUXO_APROVACAO_PEDIDO = getEnv('REACT_APP_END_POINT_FLUXO_APROVACAO_PEDIDO');

  const [fluxoAprovacao, updateFluxoAprovacao] = useState<boolean | null>(null);
  const [fluxoAprovacaoCompleto, updateFluxoAprovacaoCompleto] = useState<boolean | null>(null);
  const [lojasComAprovador, updateLojasComAprovador] = useState<number[] | null>(null);
  const { showAlert } = UseAlert();
  const navigate = useNavigate();

  /**
   *
   *
   *
   *
   *  verificar as permissões de acesso */
  const { loggedUserData } = UseAuth();
  const [showScreen, updateShowScreen] = useState<boolean>(false);
  /** Fluxo novo: uma única consulta leve traz as lojas com aprovador; as demais ficam bloqueadas no modal. */
  useEffect(() => {
    if (fluxoAprovacaoCompleto !== true || !ENDPOINT_FLUXO_APROVACAO_PEDIDO) {
      return;
    }
    new RestUseCase(`${ENDPOINT_FLUXO_APROVACAO_PEDIDO}/lojas-com-aprovador`)
      .Get()
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && Array.isArray(response.body)) {
          updateLojasComAprovador(response.body);
        }
      })
      .catch(() => updateLojasComAprovador(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fluxoAprovacaoCompleto]);

  useEffect(() => {
    const roleScreen = HeaderNavegationList.filter((header) => header.navTitle === 'Análise')[0].navItem.filter((item) => item.title === 'Sintético')[0].role;

    if (loggedUserData?.role) {
      loggedUserData.role.forEach((value) => {
        if (roleScreen.includes(value)) updateShowScreen(true);
      });
    }
    findCompanyConfiguration();
  }, [loggedUserData]);

  /**
   *
   *
   *
   *
  *  selects */
  const [filial, updateFilial] = useState<SelectOptionInterface[]>();
  const [uf, updateUf] = useState<SelectOptionInterface[]>([]);
  const [discountGroup, updateDiscountGroup] = useState<SelectOptionInterface[]>();
  const [base, updateBase] = useState<SelectOptionInterface[]>();
  const [rangeProfitability, updateRangeProfitability] = useState<SelectOptionInterface[]>();
  const [manufacturer, updateManufacturer] = useState<SelectOptionInterface[]>();
  const [marca, updateMarca] = useState<SelectOptionInterface[]>([]);
  const [campanhasAtivas, updateCampanhasAtivas] = useState<SelectOptionInterface[]>();
  /**
   *
   *
   *
   *
   *  chamada ao backend */
  const paginationDefault = '?page=0&size=12';
  const END_POINT_LAST_CHARGE = getEnv('REACT_APP_END_POINT_LAST_CHARGE')!;
  const [lastCharge, updateLastCharge] = useState<string>();
  const handleLastCharge = async () => {
    await new RestUseCase(END_POINT_LAST_CHARGE).Get().then((response) => {
      updateLastCharge(ParseDateToBrWithHours(response.body));
    });
  };
  const handleFilial = async () => {
    await new RestUseCase(`${ENDPOINT_FILIAL}?modulos=COMPRAS`).Get().then((response) => {
      const filiais = response.body || [];
      updateFilial(
        filiais.map((value: any) => {
          return { value: value.id, label: value.nome };
        })
      );
      const ufs = filiais
        .map((value: any) => value.uf)
        .filter((value: any) => !!value)
        .map((value: string) => value.toUpperCase());
      updateUf(
        Array.from(new Set<string>(ufs))
          .sort()
          .map((value) => ({ value, label: value }))
      );
    });
  };
  const handleDiscountGroup = async () => {
    await new RestUseCase(END_POINT_ORIGINAL_ITEMS_TRACKS).Get().then((response) => {
      updateDiscountGroup(
        response.body.map((value: any) => {
          return { value: value, label: value };
        })
      );
    });
  };
  const handleRangeProfitability = async () => {
    await new RestUseCase(END_POINT_ITEM_TRACKS).Get().then((response) => {
      updateRangeProfitability(
        response.body.map((value: any) => {
          return { value: value, label: value };
        })
      );
    });
  };

  const handleBase = async () => {
    await new RestUseCase(END_POINT_ITEM_BASE_CODE).Get().then((response) => {
      updateBase(
        response.body.codigos.map((value: any) => {
          return { value: value, label: value };
        })
      );
    });
  };

  const handleManufacturer = async () => {
    await new RestUseCase(ENDPOINT_MANUFACTURER).Get().then((response) => {
      updateManufacturer(
        response.body.map((value: any) => {
          return {
            value: value.codigo,
            label: `${value.codigo} - ${value.nome}`,
          };
        })
      );
    });
  };
  const handleMarca = async () => {
    await new RestUseCase(`${ENDPOINT_MANUFACTURER}/marcas`).Get().then((response) => {
      updateMarca(
        (response.body || []).map((value: any) => {
          return { value: value.id, label: String(value.siglaMarca || value.id) };
        })
      );
    });
  };
  const handleCampanhasAtivas = async () => {
    await new RestUseCase(ENDPOINT_CAMPANHAS_ATIVAS).Get().then((response) => {
      updateCampanhasAtivas(
        response.body.map((value: any) => {
          return { value: value.id, label: value.descricao };
        })
      );
    });
  };
  const handleGraphicHistory = async (id: number) => {
    const response = await new RestUseCase(`${ENDPOINT_TABLE}/historico/${id}`).Get();
    return handleRequest(response);
  };
  const handleObservationItem = async (params: { codigo: number; filial: number }) => {
    const response = await new RestUseCase(`${END_POINT_ITEM}/${params.codigo}/observacoes?filiais=${params.filial}`).Get();
    return handleRequest(response);
  };
  const handleMovement = async (params: { codigoItem: number; idFilial: number; typeMoviment: 'compra' | 'venda' }) => {
    const response = await new RestUseCase(`${END_POINT_MOVEMENT}/${params.typeMoviment}?codigoItem=${params.codigoItem}&idFilial=${params.idFilial}`).Get();
    return handleRequest(response);
  };
  const correlate = async (params: { codigoItem: number }) => {
    const response = await new RestUseCase(`${END_POINT_CORRELATE}/?codigo=${params.codigoItem}`).Get();
    return handleRequest(response);
  };
  const resume = async (params: any) => {
    showAlert({
      show: true,
      content: 'Carregando totalizadores, aguarde!',
      color: 'default',
      time: 2000,
    });

    var localStoragePlanning = getLocalStorage(LOCALSTORAGE_PLANNING);

    const resume = await new RestUseCase(ENDPOINT_TABLE! + '/resumo').Post({
      data: localStoragePlanning ? localStoragePlanning : [],
    });

    updatePanelInfo([
      [
        {
          label: 'Itens Distintos Sugeridos',
          number: resume.body.itensSugeridos,
        },
        {
          label: 'Valor Itens Sugeridos',
          number: resume.body.valorItensSugeridos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
        },
      ],
      [
        {
          label: 'Itens Distintos Salvos',
          number: resume.body.itensSalvos,
        },
        {
          label: 'Valor Itens Salvos',
          number: resume.body.valorItensSalvos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
        },
      ],
    ]);
  };
  const ENDPOINT_TIPO_REMANEJAMENTO = getEnv('REACT_APP_END_POINT_EQUALIZATION')!;
  const [typeRemanejamento, updateTypeRemanejamento] = useState<{
    dataPesquisa: string;
    tipo: string;
  }>({ dataPesquisa: '', tipo: '' });

  async function handleTypeRemanejamento(): Promise<any> {
    await new RestUseCase(ENDPOINT_TIPO_REMANEJAMENTO).Get().then((response) => {
      if (response.statusCode !== 500 && response.statusCode !== undefined) {
        if (response.body !== null && response.body !== undefined && response.body !== '') {
          updateTypeRemanejamento({
            dataPesquisa: ParseDateToBr(response.body.dataPesquisa),
            tipo: response.body.tipo,
          });
        }
      }
    });
  }

  async function findCompanyConfiguration() {
    const resultado = await buscarConfiguracaoFluxoAprovacao(loggedUserData?.companyId, loggedUserData?.role);
    updateFluxoAprovacaoCompleto(resultado.fluxoAprovacaoCompleto);
    updateFluxoAprovacao(resultado.fluxoAprovacao);
    if (!resultado.success) {
      showErrorAlert(showAlert, resultado.message);
    }
  }

  /**
   *
   *
   *
   *
   *  painel */
  const [panelInfo, updatePanelInfo] = useState<any[]>([]);

  /**
   *
   *
   *
   *
   *  gerenciador de estado */
  useEffect(() => {
    checkColumns(LOCALSTORAGE_COLUMS, ColumsTableSyntheticAdapter);
    handleFilial();
    handleDiscountGroup();
    handleRangeProfitability();
    handleBase();
    handleManufacturer();
    handleMarca();
    handleLastCharge();
    handleTypeRemanejamento();
    handleCampanhasAtivas();
  }, []);
  useEffect(() => {
    SyntheticFilterPlanningAdapter.map((value) => {
      if (value.label === 'Filial') value.field[1].optionsInput = filial;
      if (value.label === 'UF') value.field[1].optionsInput = uf;
      if (value.label === 'Grupo de desconto') value.field[1].optionsInput = discountGroup;
      if (value.label === 'Base') value.field[1].optionsInput = base;
      if (value.label === 'Lucratividade do fornecedor') value.field[1].optionsInput = rangeProfitability;
      if (value.label === 'Código do Fabricante') value.field[1].optionsInput = manufacturer;
      if (value.label === 'Marca') value.field[1].optionsInput = marca;
      if (value.label === 'Campanha ATIVA') value.field[1].optionsInput = campanhasAtivas;
    });

    SyntheticFilterPlanningAdapter.sort(function (a, b) {
      return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });
  }, [filial, uf, discountGroup, rangeProfitability, manufacturer, marca, campanhasAtivas, base]);

  return (
    <>
      {showScreen ? (
        <SyntheticPage
          /** dados / confi para o planejamento */
          optionsFiltersDefault={SyntheticFilterPlanningAdapter}
          /** processa e lista */
          processAndList={async function (params: { pagination: string; model?: any }): Promise<any> {
            let querie = params?.pagination === undefined ? paginationDefault : params?.pagination;

            if (params.model) params.model.forEach((item: any) => (querie += `&fil=${item.value}`));
            var localStoragePlanning = getLocalStorage(LOCALSTORAGE_PLANNING);

            const response = await new RestUseCase(ENDPOINT_TABLE! + querie).Put({
              headers: { 'Action-Name': 'Sintetico/Processar' },
              data: localStoragePlanning ? localStoragePlanning : undefined,
            });

            return handleRequest(response);
          }}
          /** lista */
          list={async function (params: { pagination: string; model?: any }): Promise<any> {
            /** cria a query */
            let localStorageColumsOrder: any[] = getLocalStorage(LOCALSTORAGE_COLUMS_ORDER) ?? [];

            let queryParamsOrder = '';

            localStorageColumsOrder.forEach((fe) => {
              queryParamsOrder += `&sort=${fe.ordinationName.toLowerCase()}:${fe.ordinationValue}`;
            });

            var dataPlanning = params.model ? params.model : getLocalStorage(LOCALSTORAGE_PLANNING);

            const response = await new RestUseCase(
              ENDPOINT_TABLE! + (params?.pagination === undefined ? paginationDefault : params?.pagination) + queryParamsOrder
            ).Post({
              data: dataPlanning ? dataPlanning : undefined,
            });

            return handleRequest(response);
          }}
          /** gera o pedido */
          generateOrder={async function (params: { idFilial: number; orderName: string }): Promise<any> {
            let url =
              params.idFilial === undefined || params.idFilial === null
                ? ENDPOINT_ORDER!
                : `${ENDPOINT_ORDER!}?idFilial=${params.idFilial}&orderName=${params.orderName}`;

            const response = await new RestUseCase(url).Post({});
            return handleRequest(response);
          }}
          requestOrder={async function (params: { idFilial: number; orderName: string }): Promise<any> {
            if (fluxoAprovacaoCompleto !== true) {
              let urlLegado =
                params.idFilial === undefined || params.idFilial === null
                  ? `${ENDPOINT_REQUEST_ORDER!}?orderName=${params.orderName}`
                  : `${ENDPOINT_REQUEST_ORDER!}?idFilial=${params.idFilial}&orderName=${params.orderName}`;

              const response = await new RestUseCase(urlLegado).Post({});
              return handleRequest(response);
            }
            // Fluxo novo (flag da empresa ligada): origina o pedido versionado do Sintético a partir
            // da seleção já persistida (itens "alterado"), agrupando por filial, e leva para a tela de
            // Aprovação de Pedidos. Espelha o Analítico e NÃO chama o /sintetico/solicitar-pedido legado,
            // que consumiria os itens e deixaria o novo fluxo sem itens (pedido não apareceria).
            // idFilial vem do mesmo modal do fluxo legado: quando escolhida, TODOS os itens vão para
            // essa filial em vez da filial original de cada item (sem isso o pedido era sempre gerado
            // na filial do item, ignorando a escolha do usuário).
            const resultado = await new FluxoAprovacaoPedidoUseCase(ENDPOINT_FLUXO_APROVACAO_PEDIDO!).originarDoSintetico(
              params?.orderName ?? null,
              params?.idFilial
            );
            return finalizarOriginar(
              resultado,
              () => navigate('/fluxo-aprovacao-pedido?aba=sintetico'),
              (mensagem, statusCode) => showAlertPorStatus(showAlert, mensagem, statusCode)
            );
          }}
          /** salva a pagina ou linha */
          save={async function (params: { modelItem: [{ filial: number; id: number; quantidade: number }] }): Promise<any> {
            const response = await new RestUseCase(ENDPOINT_TABLE!).Patch({ data: params });
            return handleRequest(response);
          }}
          /** salva tudo */
          saveAll={async function (params: { modelItem: [{ filial: number; id: number; quantidade: number }] }): Promise<any> {
            var localStoragePlanning = getLocalStorage(LOCALSTORAGE_PLANNING);
            const payload = {
              filtros: localStoragePlanning ? localStoragePlanning : [],
              quantidades: Array.isArray(params) ? params : [],
            };
            const response = await new RestUseCase(ENDPOINT_TABLE! + `/all`).Patch({
              data: payload,
            });
            return handleRequest(response);
          }}

          /** remove a pagina ou linha */
          remove={async function (params: { modelItem: [{ filial: number; id: number }] }): Promise<any> {
            const response = await new RestUseCase(ENDPOINT_TABLE!).Delete({ data: params });
            return handleRequest(response);
          }}
          /** remove todas as páginas */
          removeAll={async function (filtros: FilterRequest[]): Promise<any> {
            const response = await new RestUseCase(`${ENDPOINT_TABLE!}/all`).Delete({ data: filtros });
            return handleRequest(response);
          }}

          /** planejamento */
          listByIdPlanning={async function (): Promise<any> { }}
          /** planejamento lista*/
          listAllPlanning={async function (): Promise<any> {
            const response = await new RestUseCase(ENDPOINT_PLANNING!).Get();
            return handleRequest(response);
          }}
          /** planejamento cria*/
          createPlanning={async function (params?: any): Promise<any> {
            params.idEmpresa = loggedUserData?.companyId;
            const response = await new RestUseCase(ENDPOINT_PLANNING!).Post({ data: params });
            return handleRequest(response);
          }}
          /** planejamento edita*/
          editPlanning={async function (params: { model: any; id: number }): Promise<any> {
            params.model.idEmpresa = loggedUserData?.companyId;
            const response = await new RestUseCase(ENDPOINT_PLANNING! + '/' + params.id).Put({ data: params.model });
            return handleRequest(response);
          }}
          /** planejamento remove*/
          removePlanning={async function (params?: any): Promise<any> {
            const response = await new RestUseCase(ENDPOINT_PLANNING! + '/' + params.idFilter).Delete();
            return handleRequest(response);
          }}
          /** exporta arquivo */
          exportFileCSV={async function (): Promise<any> {
            var localStoragePlanning = getLocalStorage(LOCALSTORAGE_PLANNING);
            const response = await new RestUseCase(ENDPOINT_TABLE!).Post({
              headers: { accept: 'text/csv' },
              data: localStoragePlanning ? localStoragePlanning : undefined,
            });
            return handleRequest(response);
          }}
          exportFileExcel={async function (): Promise<any> {
            var localStoragePlanning = getLocalStorage(LOCALSTORAGE_PLANNING);
            var localStorageColunas: TableDescriptions[] = getLocalStorage(LOCALSTORAGE_COLUMS) ?? ColumsTableSyntheticAdapter;

            let querie = '';

            if (localStorageColunas !== null) {
              let colunsParams = localStorageColunas
                .sort((a, b) => a.order - b.order)
                .filter((item) => !item.hidden && item.columnName)
                .map((item) => item.columnName);

              colunsParams.forEach((item: any) => (querie += `&filtroColunas=${item}`));
            }

            const response = await new RestUseCase(`${ENDPOINT_TABLE!}/gerar-excel${querie === '' ? querie : '?' + querie}`).Post({
              responseType: 'blob',
              data: localStoragePlanning ? localStoragePlanning : undefined,
            });
            return handleRequest(response);
          }}
          /** alerta grafico*/
          graphicHistory={handleGraphicHistory}
          /** alerta observacao*/
          observationItem={handleObservationItem}
          /** alerta compra e venda*/
          movement={handleMovement}
          /** alerta item correlato*/
          correlate={correlate}
          /** role do usuário logado */
          loggedUserDataRole={loggedUserData?.role!}
          /** painel com os totalizadores */
          /** atualização dos totalizadores sob demanda */
          resumeTotals={resume}
          panelList={panelInfo}
          lastCharge={lastCharge!}
          typeRemanejamento={typeRemanejamento}
          fluxoAprovacao={fluxoAprovacao}
          lojasComAprovador={lojasComAprovador}
        />
      ) : (
        <ErrorNotAuthorizedPage />
      )}
    </>
  );
};
